import request from '@/request/request'

export function listUavTask(query) {
    return request({
        url: '/api/equipment-server/uav/task/list',
        method: 'get',
        params: query
    })
}
